import { TenantAuthLayoutOverride } from '../../../shared/src/types/authLayout/types'
import { LOGO_URL, LOGO_URL_WHITE, LOGO_URL_WHITE_NO_LABEL, SIDEBAR_TOP_LOGO_COLLAPSED_URL } from './constants/assets'

export const authLayout: TenantAuthLayoutOverride = {
    logoUrl: LOGO_URL,
    logoWidth: '650px',
    logoHeight: '650px',
    logoUrlWhite: LOGO_URL_WHITE,
    logoZingBlack: LOGO_URL,
    logoUrlWhiteNoLabel: LOGO_URL_WHITE_NO_LABEL,
    sidebarTopLogoCollapsedUrl: SIDEBAR_TOP_LOGO_COLLAPSED_URL,
    sidebarTopLogoWidth: '150px',
    sidebarTopLogoHeight: '130px',
    sidebarTopLogoCollapsedWidth: '80px',
    sidebarTopLogoCollapsedHeight: '80px',
    variant: 'gradient',

}
